const DEFAULT_APP_ORIGIN = 'https://app.vendaprocrm.com.br';

const LOCAL_HOSTNAMES = new Set([
  'localhost',
  '127.0.0.1',
  '0.0.0.0'
]);

const APP_HOSTNAMES = new Set([
  'app.vendaprocrm.com.br'
]);

function normalizeOrigin(candidate?: string | null) {
  const value = String(candidate || '').trim();
  if (!value) {
    return null;
  }

  try {
    return new URL(value).origin;
  } catch {
    return null;
  }
}

export function resolveProductOrigin() {
  if (typeof window !== 'undefined') {
    const currentHostname = String(window.location.hostname || '').trim().toLowerCase();
    if (APP_HOSTNAMES.has(currentHostname) || LOCAL_HOSTNAMES.has(currentHostname)) {
      return window.location.origin;
    }
  }

  const configuredOrigin = normalizeOrigin(
    import.meta.env.VITE_APP_URL || import.meta.env.VITE_APP_BASE_URL || DEFAULT_APP_ORIGIN
  );

  return configuredOrigin || DEFAULT_APP_ORIGIN;
}

export function buildProductUrl(target?: string | null) {
  const normalizedTarget = String(target || '').trim() || '/dashboard';

  if (typeof window === 'undefined') {
    return normalizedTarget;
  }

  try {
    const resolvedTarget = new URL(normalizedTarget, window.location.origin);
    const productOrigin = resolveProductOrigin();
    const currentOrigin = window.location.origin;

    if (resolvedTarget.origin !== currentOrigin) {
      return resolvedTarget.toString();
    }

    return new URL(
      `${resolvedTarget.pathname}${resolvedTarget.search}${resolvedTarget.hash}`,
      productOrigin
    ).toString();
  } catch {
    return new URL(normalizedTarget.startsWith('/') ? normalizedTarget : `/${normalizedTarget}`, resolveProductOrigin()).toString();
  }
}

export function navigateToProductLocation(target?: string | null) {
  if (typeof window === 'undefined') {
    return;
  }

  window.location.assign(buildProductUrl(target));
}
